
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/global-freight-summit",
      function () {
        return require("private-next-pages/events/global-freight-summit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/global-freight-summit"])
      });
    }
  